module.exports = __webpack_public_path__ + "media/images/freedom-792b2e3d.png";